// extracted by mini-css-extract-plugin
export default {"wrapper":"Slider_wrapper__TRumq","Root":"Slider_Root__utVeQ","Track":"Slider_Track__QnRGt","Range":"Slider_Range__dx5SW","Thumb":"Slider_Thumb__rdF31"};